var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 104,
    height: 30,
    viewBox: "0 0 104 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XLR8 Logo-w 1",
    clipPath: "url(#clip0_0_5371)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.5 0.155H35.19V22.955C35.1893 23.0513 35.2077 23.1467 35.2441 23.2359C35.2805 23.325 35.3342 23.4061 35.402 23.4744C35.4699 23.5427 35.5506 23.597 35.6395 23.634C35.7284 23.671 35.8237 23.69 35.92 23.69H46.92V27.03H33.555C33.0081 27.0247 32.4855 26.8038 32.1007 26.4152C31.7158 26.0266 31.5 25.5019 31.5 24.955V0.155Z",
    fill: "#006C35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M72.025 27.03L66.69 18.58C66.075 18.635 65.575 18.66 65.19 18.66H58.355V27.03H54.67V0.155H65.17C68.59 0.155 71.2267 0.936667 73.08 2.5C74.9333 4.06333 75.8617 6.29667 75.865 9.2C75.9376 11.1434 75.4142 13.0625 74.365 14.7C73.3023 16.225 71.769 17.3595 70 17.93L76.26 27.03H72.025ZM65.19 15.32C67.4967 15.32 69.2633 14.82 70.49 13.82C71.7167 12.82 72.3317 11.33 72.335 9.35C72.335 7.43 71.72 5.97667 70.49 4.99C69.26 4.00333 67.4933 3.50667 65.19 3.5H58.355V15.32H65.19Z",
    fill: "#006C35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M100.32 1.825C101.083 2.40969 101.694 3.16905 102.102 4.03916C102.51 4.90928 102.703 5.8647 102.665 6.825C102.686 8.07903 102.302 9.30633 101.57 10.325C100.791 11.3832 99.7259 12.1968 98.5 12.67C100.072 13.1134 101.477 14.0151 102.535 15.26C103.511 16.4547 104.03 17.9576 104 19.5C104.041 20.589 103.816 21.6716 103.344 22.6542C102.873 23.6368 102.17 24.49 101.295 25.14C99.4917 26.5267 97.0417 27.2183 93.945 27.215C90.8483 27.2117 88.3967 26.5267 86.59 25.16C85.7177 24.5203 85.0152 23.677 84.5437 22.7035C84.0722 21.73 83.8461 20.656 83.885 19.575C83.8532 18.0082 84.3856 16.4821 85.385 15.275C86.478 14.0117 87.9229 13.103 89.535 12.665C88.27 12.1658 87.1617 11.3371 86.325 10.265C85.5658 9.23934 85.1684 7.99078 85.195 6.715C85.1596 5.76775 85.3539 4.82599 85.7614 3.97013C86.1689 3.11426 86.7774 2.3697 87.535 1.8C89.095 0.6 91.22 0 93.91 0C96.6 0 98.7367 0.608333 100.32 1.825ZM89.11 15.605C88.5526 16.0103 88.1036 16.5466 87.8027 17.1667C87.5019 17.7867 87.3584 18.4713 87.385 19.16C87.3508 19.879 87.4897 20.5957 87.7898 21.25C88.09 21.9042 88.5427 22.4769 89.11 22.92C90.26 23.8167 91.8733 24.265 93.95 24.265C96.0267 24.265 97.6317 23.8167 98.765 22.92C99.336 22.4867 99.7935 21.9215 100.098 21.2728C100.403 20.624 100.546 19.9111 100.515 19.195C100.54 18.5019 100.393 17.8134 100.087 17.1907C99.7821 16.568 99.3279 16.0302 98.765 15.625C97.5983 14.755 95.98 14.32 93.91 14.32C91.84 14.32 90.24 14.7483 89.11 15.605ZM89.82 3.84C89.3325 4.21138 88.9417 4.69473 88.6806 5.24913C88.4195 5.80353 88.2958 6.41267 88.32 7.025C88.2923 7.64356 88.4141 8.25968 88.6753 8.8211C88.9364 9.38252 89.3291 9.87268 89.82 10.25C90.82 11.02 92.1967 11.405 93.95 11.405C95.7033 11.405 97.0717 11.02 98.055 10.25C98.5352 9.86633 98.9169 9.37352 99.1682 8.81258C99.4196 8.25163 99.5333 7.63877 99.5 7.025C99.528 6.41619 99.4101 5.80952 99.1561 5.2555C98.9022 4.70149 98.5195 4.21618 98.04 3.84C97.07 3.07 95.7017 2.685 93.935 2.685C92.1683 2.685 90.7967 3.07 89.82 3.84Z",
    fill: "#006C35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.805 0.155H18.465L13.205 7.575L15.16 10.99L22.805 0.155Z",
    fill: "url(#paint0_linear_0_5371)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.3 0.155H0L7.81 11.315L9.76 7.9L4.3 0.155Z",
    fill: "url(#paint1_linear_0_5371)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.68 19.07C15.1455 18.8168 14.5615 18.6853 13.97 18.685C13.065 18.685 12.235 18.98 11.08 19.1H10.81C10.4817 19.1053 10.1555 19.0459 9.8502 18.9251C9.54486 18.8043 9.2663 18.6246 9.03043 18.3961C8.79456 18.1677 8.606 17.895 8.47553 17.5937C8.34505 17.2924 8.27521 16.9683 8.27 16.64C8.32 15.435 9.705 14.36 10.92 14.015C11.3582 13.893 11.8102 13.8275 12.265 13.82C14.09 13.82 15.65 14.925 16.765 16.07L11.58 7.045L5.5 17.72L0.15 27.03H1.69H1.815C7.935 26.75 8.065 21.95 11.58 21.95C15.19 21.95 15.225 27.03 21.875 27.03H23C23 27.03 19.9 20.755 15.68 19.07Z",
    fill: "#006C35"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_5371",
    x1: 12.295,
    y1: 11.94,
    x2: 18.07,
    y2: 3.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006C35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_5371",
    x1: 11.17,
    y1: 12.04,
    x2: 6.225,
    y2: 5.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006C35"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_5371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.93ed1c77e00b64c208d08407694b0094.svg";
export { ForwardRef as ReactComponent };